import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { busLaiXeApi } from "../../../api/bus/busLaiXeApi";
import { busMonitoringApi } from "../../../api/bus/busMonitoringApi";
import { busTuyenDuongApi } from "../../../api/bus/busTuyenDuongApi";
import { busXeApi } from "../../../api/bus/busXeApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { BusLaiXeItemResponse } from "../../../models/response/bus/bus_laixe";
import {
	eBusTuyenDuongActionTypeIds,
	IBusTuyenDuongDeleteStart,
	IBusTuyenDuongImportStart,
	IBusTuyenDuongLoadLaiXeStart,
	IBusTuyenDuongLoadMonitoringStart,
	IBusTuyenDuongLoadStart,
	IBusTuyenDuongLoadXeStart,
	IBusTuyenDuongSaveStart,
	IBusTuyenDuongValidateImportStart
} from "../../action-types/bus/IBusTuyenDuongActionTypes";
import { busTuyenDuongActions } from "../../actions/bus/busTuyenDuongActions";

export function* busTuyenDuongSaga(): any {
	yield takeLatest(eBusTuyenDuongActionTypeIds.LOAD_START, loadBusTuyenDuongWorker)
	yield takeLatest(eBusTuyenDuongActionTypeIds.LOAD_XE_START, loadBusXeWorker)
	yield takeLatest(eBusTuyenDuongActionTypeIds.LOAD_LAIXE_START, loadBusLaiXeWorker)
	yield takeLatest(eBusTuyenDuongActionTypeIds.LOAD_MONITORING_START, loadBusMonitoringWorker)
	yield takeEvery(eBusTuyenDuongActionTypeIds.SAVE_START, saveBusTuyenDuongWorker)
	yield takeEvery(eBusTuyenDuongActionTypeIds.DELETE_START, deleteBusTuyenDuongWorker)
	yield takeEvery(eBusTuyenDuongActionTypeIds.VALIDATE_IMPORT_START, validateImportBusTuyenDuongWorker)
	yield takeEvery(eBusTuyenDuongActionTypeIds.IMPORT_START, importBusTuyenDuongWorker)
}

function* loadBusTuyenDuongWorker(action: IBusTuyenDuongLoadStart): any {
	const res: IBaseResponeModel = yield call([busTuyenDuongApi, busTuyenDuongApi.SelectAsync], action.payload)
	if (res.is_success) {
		yield put(busTuyenDuongActions.loadBusTuyenDuongSuccess(res.data || []))
	} else {
		yield put(busTuyenDuongActions.loadBusTuyenDuongError(res.message || "Không tải được danh sách tuyến đường"))
	}
}

function* loadBusXeWorker(action: IBusTuyenDuongLoadXeStart): any {
	const res: IBaseResponeModel = yield call([busXeApi, busXeApi.SelectByCoSo], action.payload)
	if (res.is_success) {
		yield put(busTuyenDuongActions.loadBusXeSuccess(res.data || []))
	} else {
		yield put(busTuyenDuongActions.loadBusXeError(res.message || "Không tải được danh sách xe"))
	}
}

function* loadBusLaiXeWorker(action: IBusTuyenDuongLoadLaiXeStart): any {
	const res: IBaseResponeModel = yield call([busLaiXeApi, busLaiXeApi.SelectAll])
	if (res.is_success) {
		const data: BusLaiXeItemResponse[] = res.data || [];
		yield put(busTuyenDuongActions.loadBusLaiXeSuccess(data.filter((x: BusLaiXeItemResponse) => x.dm_coso_id == action.payload)))
	} else {
		yield put(busTuyenDuongActions.loadBusLaiXeError(res.message || "Không tải được danh sách lái xe"))
	}
}

function* loadBusMonitoringWorker(action: IBusTuyenDuongLoadMonitoringStart): any {
	const res: IBaseResponeModel = yield call([busMonitoringApi, busMonitoringApi.SelectByCoSo], action.payload)
	if (res.is_success) {
		yield put(busTuyenDuongActions.loadBusMonitoringSuccess(res.data || []))
	} else {
		yield put(busTuyenDuongActions.loadBusMonitoringError(res.message || "Không tải được danh sách Cô Mo"))
	}
}

function* saveBusTuyenDuongWorker(action: IBusTuyenDuongSaveStart): any {
	let res: IBaseResponeModel;
	const is_update = action.payload.id > 0;
	if (is_update) {
		res = yield call([busTuyenDuongApi, busTuyenDuongApi.Update], action.payload);
	} else {
		res = yield call([busTuyenDuongApi, busTuyenDuongApi.Insert], action.payload);
	}
	if (res.is_success) {
		yield put(busTuyenDuongActions.saveBusTuyenDuongSuccess(is_update))
	} else {
		yield put(busTuyenDuongActions.saveBusTuyenDuongError(res.message || "Không lưu được tuyến đường"))
	}
}

function* deleteBusTuyenDuongWorker(action: IBusTuyenDuongDeleteStart): any {
	const res: IBaseResponeModel = yield call([busTuyenDuongApi, busTuyenDuongApi.DeletesAsync], action.payload)
	if (res.is_success) {
		yield put(busTuyenDuongActions.deleteBusTuyenDuongSuccess())
	} else {
		yield put(busTuyenDuongActions.deleteBusTuyenDuongError(res.message || "Không xóa được tuyến đường"))
	}
}

function* validateImportBusTuyenDuongWorker(action: IBusTuyenDuongValidateImportStart): any {
	const res: IBaseResponeModel = yield call([busTuyenDuongApi, busTuyenDuongApi.ValidateImport], action.payload)
	if (res.is_success) {
		yield put(busTuyenDuongActions.validateImportBusTuyenDuongSuccess(res.data || []))
	} else {
		yield put(busTuyenDuongActions.validateImportBusTuyenDuongError(res.message || "Có lỗi"))
	}
}

function* importBusTuyenDuongWorker(action: IBusTuyenDuongImportStart): any {
	const res: IBaseResponeModel = yield call([busTuyenDuongApi, busTuyenDuongApi.Import], action.payload)
	if (res.is_success) {
		yield put(busTuyenDuongActions.importBusTuyenDuongSuccess())
	} else {
		yield put(busTuyenDuongActions.importBusTuyenDuongError(res.message || "Có lỗi"))
	}
}
